import { inject } from '@angular/core';
import { SplashScreenStateService } from '../common/services/splash-screen-state.service';
import { ConfigService } from '../config/services/config.service';
import { Router } from '@angular/router';
import { LoggingService } from '../logging/logging.service';

export const TaskFeatureGuard = () => {
    const router = inject(Router);
    const configService = inject(ConfigService);
    const splashScreenStateService = inject(SplashScreenStateService);
    const log = inject(LoggingService).getLogger(TaskFeatureGuard.name);

    if (configService.config()?.configuration.features?.task?.enabled) {
        splashScreenStateService.stop();
        return true;
    } else {
        log.info("Feature task isn't enabled");
        return router.navigate(['/']);
    }
};
